var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadgeError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.174 28.5266C13.3098 28.5896 13.46 28.623 13.6094 28.623H13.6154C13.7674 28.6223 13.9199 28.587 14.056 28.5209C24.8584 23.3101 26.6891 12.0674 26.9925 8.74574C27.0621 7.98729 26.641 7.281 25.9451 6.98828C23.7947 6.08272 22.3328 4.05769 22.1301 1.70354C22.0675 0.978865 21.457 0.414062 20.7378 0.414062H20.7293L6.17588 0.500753C5.44218 0.504881 4.84612 1.07043 4.78988 1.81612C4.6108 4.17103 3.17041 6.2107 1.03073 7.13915C0.341801 7.43787 -0.0688933 8.14791 0.00954569 8.90598C0.351421 12.2239 2.31202 23.4445 13.174 28.5266Z",
    fill: "url(#paint0_linear_7643_17371)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35613 12.4079C3.44198 12.7093 3.84271 12.9853 4.22827 12.884C4.60644 12.7845 4.8303 12.4135 4.72743 12.0525C4.54649 11.4164 4.39441 10.7715 4.2749 10.1327C6.20493 8.93295 7.63728 7.14236 8.33995 5.05105L18.5999 4.99351C19.3281 7.07636 20.7823 8.85142 22.7271 10.0293C22.6158 10.6699 22.4715 11.3169 22.2979 11.9554C22.1995 12.3179 22.4278 12.6878 22.8074 12.7817C23.1878 12.8756 23.5752 12.6578 23.6737 12.2953C23.8772 11.5456 24.0429 10.7846 24.1658 10.0335C24.2346 9.61382 24.0333 9.2012 23.6537 8.98237C21.842 7.93865 20.5029 6.30125 19.8832 4.37194C19.7437 3.93815 19.3148 3.63672 18.839 3.63672H18.8323L8.09056 3.69672C7.61175 3.69955 7.18327 4.00698 7.04895 4.44395C6.45321 6.37996 5.13409 8.03219 3.33541 9.09637C2.95836 9.31909 2.76262 9.73383 2.83625 10.1531C2.96872 10.9025 3.14337 11.661 3.35613 12.4079Z",
    fill: "#FD504F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1312 14.5697C21.7718 14.4198 21.3603 14.5926 21.2118 14.9544C19.5847 18.9249 17.0088 21.9437 13.5535 23.9304C10.0715 21.9821 7.45823 18.9888 5.78524 15.0308C5.63268 14.6708 5.21902 14.5032 4.86146 14.6564C4.50354 14.8097 4.33705 15.2261 4.48924 15.5861C6.31516 19.9052 9.19173 23.1613 13.039 25.2633C13.2011 25.3523 13.3786 25.3962 13.5557 25.3962C13.7373 25.3962 13.9184 25.3501 14.0834 25.2574C17.9018 23.1126 20.738 19.8281 22.5137 15.4949C22.6622 15.1331 22.4909 14.7188 22.1312 14.5697Z",
    fill: "#FD504F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7643_17371",
    x1: -2.6194,
    y1: -20.1382,
    x2: 13.5,
    y2: 28.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD504F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570871,
    stopColor: "#161D26"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeError);
export default __webpack_public_path__ + "static/media/badgeError.6e8f95c5eaff1f2dc4da1e69312ae16e.svg";
export { ForwardRef as ReactComponent };